import * as icons from '@styled-icons/material';
import _ from 'lodash';
import React from 'react';
import styled, {css} from 'styled-components';

const iconSetup = (type) => css`
    width: var(--icon-size-${type || 'default'});
`;

const IconWrapper = styled.span`
    --icon-size-sm: 12px;
    --icon-size-md: 20px;
    --icon-size-lg: 32px;
    svg {
        ${({type}) => iconSetup(type)};

        color: ${({color}) => color};
    }
`;

// Because the same icon can be used many times on the same page, we cache the lookup of the icon name in the icon set
const cachedIconLookup = _.memoize((name) => {
    if (!name) return icons.Error;
    let iconRealName = _.findKey(icons, (_, n) => n.toUpperCase() == (name || '').toUpperCase());

    // eslint-disable-next-line import/namespace
    let RenderIcon = icons.Error;
    if (iconRealName != null) {
        // eslint-disable-next-line import/namespace
        RenderIcon = icons[iconRealName];
    }

    return RenderIcon;
});

const Icon = ({name, type = undefined, children = undefined, title = undefined, color = undefined}) => {
    const RenderIcon = cachedIconLookup(name);
    if (RenderIcon == null) return null;

    return (
        <IconWrapper type={type} color={color}>
            <RenderIcon color={color} title={title} />
            {children}
        </IconWrapper>
    );
};

Icon.Wrapper = IconWrapper;
export {Icon, IconWrapper};
